<template>
    <div v-if="event.add_sponsors && event.sponsor_view_delegate && event.sponsors.length > 0" class="row">
        <div class="col-md-12" style="padding-right: 0">
            <div class="card">
                <div class="card-header hg-underline" :style="underlineOverride">
                    {{event.sponsor_title || " Sponsors "}}
                </div>
                <div class="card-body">
                    <el-carousel :interval="3500" type="card" height="200px">
                        <el-carousel-item v-for="(sponsor, idx) in event.sponsors" align="center" :key="idx">
                            <img class="img-fluid mt-4" style="max-height:125px " :src=" 'https://s3-eu-west-1.amazonaws.com/' + imageBucket + '/sponsors/' + event.id + '/' + sponsor.sponsor_file " :alt='sponsor.sponsor_file'/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  computed: {
    underlineOverride() {
      return {
        borderBottom: "4px solid " + this.event.phcolour
      };
    }
  },
  props: ["event"],

  data() {
    return {
      imageBucket: window.imageBucket
    };
  },
  methods: {
    topLineOverride() {
      return { borderTop: "4px solid " + this.event.phcolour };
    }
  }
};
</script>
